// TermsAndConditionsModal.jsx
import { Modal, Button } from 'react-bootstrap';

const TermsAndConditionsModal = ({ show, handleClose }) => (
    <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton className="bg-primary text-white">
            <Modal.Title>Términos y Condiciones</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto', fontSize: '0.95rem', lineHeight: '1.6' }}>
            <div className="p-2">
                <h5 className="mb-3" style={{ color: '#b5430f' }}>1. Aceptación de Términos</h5>
                <p className="text-muted">
                    Al registrarse y utilizar este sitio web, usted acepta los presentes Términos y
                    Condiciones de uso.
                </p>

                <h5 className="mb-3 mt-4" style={{ color: '#b5430f' }}>2. Protección de Datos Personales</h5>
                <p className="text-muted">
                    De acuerdo con la Ley Orgánica de Protección de Datos Personales de Ecuador, sus
                    datos serán tratados de forma confidencial y únicamente con fines relacionados con
                    la prestación del servicio. Usted puede ejercer sus derechos de acceso,
                    rectificación, actualización y eliminación en cualquier momento escribiéndonos al
                    correo indicado.
                </p>

                <h5 className="mb-3 mt-4" style={{ color: '#b5430f' }}>3. Uso de la Información</h5>
                <p className="text-muted">
                    Los datos personales proporcionados serán utilizados para crear su cuenta, procesar
                    pedidos, comunicarnos con usted y mejorar nuestros servicios. No compartimos su
                    información con terceros sin su consentimiento, salvo obligación legal.
                </p>

                <h5 className="mb-3 mt-4" style={{ color: '#b5430f' }}>4. Cookies y Tecnologías Similares</h5>
                <p className="text-muted">
                    Este sitio utiliza cookies propias y de terceros para mejorar su experiencia de
                    navegación. Usted puede configurar su navegador para rechazar cookies, aunque esto
                    puede limitar el funcionamiento del sitio.
                </p>

                <h5 className="mb-3 mt-4" style={{ color: '#b5430f' }}>5. Responsabilidad del Usuario</h5>
                <p className="text-muted">
                    Usted se compromete a proporcionar información veraz y a hacer un uso adecuado del
                    sitio. Nos reservamos el derecho de suspender cuentas que incumplan estos términos.
                </p>

                <h5 className="mb-3 mt-4" style={{ color: '#b5430f' }}>6. Modificaciones</h5>
                <p className="text-muted">
                    Nos reservamos el derecho de modificar estos términos en cualquier momento. Los
                    cambios serán publicados y entrarán en vigor inmediatamente.
                </p>

                <h5 className="mb-3 mt-4" style={{ color: '#b5430f' }}>7. Contacto</h5>
                <p className="text-muted">
                    Si tiene preguntas sobre estos Términos y Condiciones, puede contactarnos a:
                    <a href="mailto:clientes@homesanty.com" style={{ color: '#b5430f', textDecoration: 'none', marginLeft: '5px' }}>clientes@homesanty.com</a>
                </p>
            </div>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
                Cerrar
            </Button>
            <Button 
                variant="primary" 
                onClick={handleClose}
                style={{ backgroundColor: '#b5430f', borderColor: '#b5430f' }}
            >
                Aceptar
            </Button>
        </Modal.Footer>
    </Modal>
);

export default TermsAndConditionsModal;
